/**
 * Wizard factory/service
 */
angular.module("wizard").factory("wizardService", ['$rootScope', '$http', function ($rootScope, $http) {
    return {
        getWizardFreelancerData: function () {
            var promise = $http.get("../api/wizard/get-wizard-data.json").then(function (resp) {
                if (resp.data.success) {
                    return resp.data;
                } else {
                    return null;
                }
            });
            return promise;
        },
        saveWizardFreelancerData: function (wizardData, stepName) {
            var promise = $http({
                url: '../api/wizard/save-wizard-data.json?stepName='+stepName,
                method: 'POST',
                data: wizardData
            }).then(function (data) {
                return data.data;
            });
            return promise;
        },

        getWizardSettings: function () {
            var promise = $http.get("../api/wizard/get-wizard-settings.json").then(function (resp) {
                if (resp.data.success) {
                    return resp.data.item;
                } else {
                    return null;
                }
            });
            return promise;
        },
    };
}]);
